import LinkPattern from 'umg-ember-backend/components/record-explorer/for/link-pattern';

<template>
  <LinkPattern @records={{@model}} @recordType='link-pattern' />
</template>
